/** Local browser diagnostics only. No document/chat identifiers or content. */
export function loadingTiming(
  name: string,
  start: number,
  detail?: Record<string, string | number>,
) {
  if (typeof performance === "undefined") return;
  const key = `garden:${name}`;
  if (performance.getEntriesByName(key).length >= 100)
    performance.clearMeasures(key);
  performance.measure(key, { start, end: performance.now(), detail });
}
